var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Component, Children } from 'react';
import PropTypes from 'prop-types';
import StylePropType from 'react-style-proptype';
import { cx } from 'emotion';
import * as colors from './colors';
import StepGroup from './StepGroup';
import { mapBsStyleToColor, deprecatedProp as deprecated } from './utils';
export default class Stepper extends Component {
    render() {
        const _a = this.props, { children, activeStep, bsStyle, small, color, partial, vertical, className, style, status } = _a, rest = __rest(_a, ["children", "activeStep", "bsStyle", "small", "color", "partial", "vertical", "className", "style", "status"]);
        const activeColor = color || mapBsStyleToColor(status || bsStyle || 'success', { fallback: colors.success.base });
        const totalSteps = Children.count(children);
        const steps = Children.map(children, (step, index) => {
            const last = index === totalSteps - 1;
            const controlProps = { index, activeColor, small, vertical };
            const { props: { overrideStatus, overrideBsStyle } } = step;
            // Extended from https://github.com/callemall/material-ui/blob/master/src/Stepper/Stepper.js
            const activeSteps = activeStep.toString().split('.');
            const activeIndex = parseInt(activeSteps[0], 10);
            controlProps.activeSubStep = activeSteps[1] ? parseInt(activeSteps[1], 10) : undefined;
            const connectorColor = index >= activeIndex
                ? colors.alloy : (overrideStatus || overrideBsStyle) ? mapBsStyleToColor(overrideStatus || overrideBsStyle, { fallback: colors.alloy }) : colors.success.base;
            controlProps.connectorColor = connectorColor;
            const connector = vertical ? (React.createElement("div", { style: {
                    flex: '1 1 auto',
                    borderRight: `2px solid ${connectorColor}`,
                    paddingRight: small ? '6px' : '9px',
                    margin: '4px 0',
                    flexDirection: 'column',
                } })) : (React.createElement("div", { style: {
                    flex: '1 1 auto',
                    borderTop: `2px solid ${connectorColor}`,
                    marginTop: small ? '6px' : '9px',
                } }));
            if (activeIndex === index) {
                controlProps.active = true;
                controlProps.partial = partial;
            }
            else if (activeIndex > index) {
                controlProps.completed = true;
            }
            else if (activeIndex < index) {
                // do we want to add anything here?
            }
            return [React.cloneElement(step, Object.assign(Object.assign(Object.assign({}, controlProps), step.props), { index: controlProps.index })), !last && !(step.type === StepGroup) && connector];
        });
        const stepperStyle = vertical
            ? {
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                alignItems: 'flex-start',
                height: '100%',
                width: 'fit-content',
            }
            : {
                display: 'flex',
                justifyContent: 'space-between',
                padding: '14px 0 0',
                marginBottom: '30px',
            };
        return (React.createElement("div", Object.assign({ className: cx('stepper', className), style: Object.assign(Object.assign({}, stepperStyle), style) }, rest), steps));
    }
}
Stepper.propTypes = {
    children: PropTypes.arrayOf(PropTypes.node),
    className: PropTypes.string,
    activeStep: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    partial: PropTypes.bool,
    status: PropTypes.oneOf(['success', 'none', 'warning', 'danger']),
    color: PropTypes.string,
    small: PropTypes.bool,
    vertical: PropTypes.bool,
    style: StylePropType,
    bsStyle: deprecated(PropTypes.oneOf(['success', 'none', 'warning', 'danger']), 'Use `status` instead.'),
};
Stepper.defaultProps = {
    className: '',
    small: false,
    style: {},
    vertical: false,
};
